import React from 'react'
import "../../src/assets/css/--component-card-image.css";

export const CardImage = ({ type = "" }) => {
    const getCardImagePath = (type = "") => {
        const normalized = type.trim().toLowerCase();
    
        switch (normalized) {
          case "american express":
          case "amex":
            return "/payment-cards/american-express.png";
          case "cirrus":
            return "/payment-cards/cirrus.png";
          case "delta":
            return "/payment-cards/delta.png";
          case "diners":
            return "/payment-cards/diners-club.png";
          case "direct debit":
            return "/payment-cards/direct-debit.png";
          case "discover":
            return "/payment-cards/discover.png";
          case "ebay":
            return "/payment-cards/ebay.png";
          case "google checkout":
            return "/payment-cards/google-checkout.png";
          case "jcb":
            return "/payment-cards/jcb.png";
          case "mada":
            return "/payment-cards/mada.png";
          case "maestro":
            return "/payment-cards/maestro.png";
          case "mastercard":
            return "/payment-cards/mastercard.png";
          case "moneybookers":
            return "/payment-cards/moneybookers.png";
          case "paypal":
            return "/payment-cards/paypal.png";
          case "sagepay":
            return "/payment-cards/sagepay.png";
          case "solo":
            return "/payment-cards/solo.png";
          case "switch":
            return "/payment-cards/switch.png";
          case "visa":
            return "/payment-cards/visa.png";
          case "visa electron":
            return "/payment-cards/visa-electron.png";
          case "western union":
            return "/payment-cards/western-union.png";
          default:
            return "/payment-cards/undefined.png";
        }
      };
  return (
    <img
    className="cardicon"
    src={getCardImagePath(type)}
    alt={type}
    width={50}
    height={30}
  />
  )
}
